import {
	BrukerrolleContextDto,
	ElevFeatureToggleContext,
	ProverFeatureToggleContext
} from "@generated/types/contextModels";

export interface CommonContext {
	erBrukerstotte: boolean;
	brukerrolle: BrukerrolleContextDto;
	baseAppUrl: string;
}

const getSpecificContext = <T>() => {
	if (window.PAS !== undefined) {
		return window.PAS._context as T;
	}

	throw new Error("Context er ikke satt");
};

export const getCommonContext = getSpecificContext<CommonContext>;

export const getAppSpecificContext = <T>() => getSpecificContext<CommonContext & T>();

export const getElevAppSpecificContext = <T>() => getAppSpecificContext<T>();

export const getPrøverFeatureToggleContext = getSpecificContext<ProverFeatureToggleContext>;

export const getElevFeatureToggleContext = getSpecificContext<ElevFeatureToggleContext>;
